import Enfinity from "@/assets/images/enfinity-microsoft.png";
import Bilibili from "@/assets/svg/bilibili.svg";
import Facebook from "@/assets/svg/facebook.svg";
import Msn from "@/assets/svg/msn.svg";
import Snapchat from "@/assets/svg/snapchat.svg";
import Tiktok from "@/assets/svg/tiktok.svg";
import YouTube from "@/assets/svg/yt.svg";
import useCountUp from "@/hooks/useCountUp";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { formatToK } from "@/utils/formatNumber";
import startTypewriter from "@/utils/typewriterAnimation";
import { useEffect } from "react";

export default function Platforms({ partners }) {
  const { ref, isVisible } = useScrollReveal();

  const creators = useCountUp(3000, 2000);
  const revenue = useCountUp(70, 2000);
  const employees = useCountUp(100, 2000);

  const platforms = [
    { name: "msn", icon: Msn },
    { name: "youtube", icon: YouTube },
    { name: "snapchat", icon: Snapchat },
    { name: "facebook", icon: Facebook },
    { name: "tiktok", icon: Tiktok },
    { name: "bilibili", icon: Bilibili },
  ];

  useEffect(() => {
    startTypewriter({
      elementId: "partnersTypewriter",
      words: ["Our Partners"],
    });
  }, []);

  return (
    <div
      ref={ref}
      id={partners ? "partners" : "stats"}
      className={`${
        isVisible ? "bounce-up" : ""
      } flex flex-col justify-center py-20 px-10 lg:px-40 lg:py-28 items-center relative overflow-hidden rounded-3xl animate-slide-up will-change-transform 4xl:max-w-[100rem] 4xl:mx-auto space-y-14 ${
        partners ? "-mb-[265px]" : ""
      }`}
    >
      {partners ? (
        <div className="space-y-8 text-center">
          <h1 className="adce-hero font-bold text-4xl md:text-6xl text-primary uppercase">
            <span id="partnersTypewriter"></span>
            <span className="border-r-8 border-primary animate-pulse ml-1"></span>
          </h1>
          <p className="text-lg text-center max-w-md">
            These platforms are where your content gains visibility, reaches new
            audiences, and attracts advertisers.
          </p>
        </div>
      ) : (
        <>
          <p className="text-lg text-center max-w-4xl">
            Adcelerate is an official distribution brand of Enfinity, a leading
            content monetization company & digital rights technology developer
            with 3,500+ creators, 100+ employees, and $70M in top-line revenue.
          </p>

          <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-0 lg:justify-evenly w-full">
            <div className="space-y-4 text-center" ref={creators.ref}>
              <h1 className="adce-hero text-primary text-6xl font-bold">
                {formatToK(creators.count)}k
              </h1>
              <p>creators across the globe</p>
            </div>
            <div className="space-y-4 text-center" ref={revenue.ref}>
              <h1 className="adce-hero text-primary text-6xl font-bold">
                ${revenue.count} M
              </h1>
              <p>dollars in top-line revenue</p>
            </div>
            <div className="space-y-4 text-center" ref={employees.ref}>
              <h1 className="adce-hero text-primary text-6xl font-bold">
                {employees.count}+
              </h1>
              <p>employees and growing</p>
            </div>
          </div>
        </>
      )}

      {/* Infinite scroll row */}
      <div className={`${partners ? "scroll-inner2" : "scroll-inner"} w-full`}>
        <div className="flex">
          {[1, 2, 3].map((dup) => (
            <section
              key={dup}
              className="scroll-section-left"
              style={{ "--speed": "20000ms" }}
            >
              {platforms.map((platform, index) => (
                <div
                  key={`${platform.name}-${index}-${dup}`}
                  className="flex justify-center items-center w-40 h-16 mx-4 hover:scale-110 transition-transform duration-300"
                >
                  <img
                    src={platform.icon}
                    alt={platform.name}
                    className="max-h-32 object-contain"
                  />
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>

      {!partners && (
        <a
          href="https://support.microsoft.com/en-us/topic/msn-content-provider-partner-directory-ddbc2fb3-2693-4717-88a0-7713122c8026"
          target="_blank"
          className="!mt-6 !z-40"
        >
          <img src={Enfinity} alt="Enfinity" />
        </a>
      )}
    </div>
  );
}
